import script from "./UserLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserLayout.vue?vue&type=script&setup=true&lang=ts"

import "./UserLayout.vue?vue&type=style&index=0&id=0bf363ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf363ec"]])

export default __exports__